import React from "react"

import { Button } from "components/Button"
import PharmaSupportContact from "components/PharmaSupportContact/PharmaSupportContact"
import PreviousButton from "components/Previous/PreviousButton"
import { Title } from "components/Title/Title"
import { useLanguage } from "locales"

import styles from "./PharmacyOwnerInfo.module.scss"

// Téléexpertise menu of the "Espace professionnel" modal. The title lives here, not in the
// modal header, so the button stays centered between the title and the support block
const TeleexpertiseMenu: React.FC<{ onBack: () => void; onOwnerInfo: () => void }> = ({
  onBack,
  onOwnerInfo,
}) => {
  const { languages } = useLanguage()
  return (
    <>
      <PreviousButton onClick={onBack} />
      <Title
        text={<>{languages.teleexpertiseCta.toUpperCase()}</>}
        style={{ marginTop: 80 }}
      />
      <div className={styles.MenuButtons}>
        <Button className={styles.MenuButton} onClick={onOwnerInfo}>
          {languages.ownerInfoTitle.toUpperCase()}
        </Button>
      </div>
      <PharmaSupportContact />
    </>
  )
}

export default TeleexpertiseMenu
